export default class {
  constructor(scrollbarId) {
    this.scrollbarId = scrollbarId;
  }

  findFocusedElementFrom(elementIds) {
    try {
      return this.findFocusedElementFromUnsafe(elementIds);
    } catch (error) {
      // This can happen if the elements are not yet accessible.
      console.warn(`Fail to select focused element between elements ${elementIds}`, error);
      return undefined;
    }
  }

  getScrollOffset() {
    return document.getElementById(this.scrollbarId).firstChild.scrollTop;
  }

  findFocusedElementFromUnsafe(elementIds) {
    const scrollbarElement = document.getElementById(this.scrollbarId);
    const scrollbarPosition = scrollbarElement.getBoundingClientRect();
    const midScrollBarHeight = scrollbarPosition.top + (scrollbarElement.offsetHeight / 2);

    let focusedElement;
    let minValue = Number.MAX_VALUE;

    elementIds.forEach(id => {
      const element = document.getElementById(id);
      const minDistance = this.computeMinDistance(element, midScrollBarHeight);

      if (minDistance <= minValue) {
        minValue = minDistance;
        focusedElement = element;
      }
    });

    return focusedElement;
  }

  computeMinDistance(element, midScrollBarHeight) {
    const position = element.getBoundingClientRect();
    const relativeTopPosition = position.top - midScrollBarHeight;
    const relativeBotPosition = position.bottom - midScrollBarHeight;

    if (relativeTopPosition < 0 && relativeBotPosition > 0) {
      // Is in the middle of the screen.
      return 0;
    }

    const distanceFromTheTop = Math.abs(relativeTopPosition);
    const distanceFromTheBot = Math.abs(relativeBotPosition);

    return Math.min(distanceFromTheTop, distanceFromTheBot);
  }
}
